import { ADD_CLOSEST_LVZ_PATHS, RESET_CLOSEST_LVZ_PATHS} from "./closestLvzPathsReducer"

export const addClosestLvzPaths = (data) => ({
    type: ADD_CLOSEST_LVZ_PATHS,
    payload: data
})

export const resetClosestLvzPaths = () => ({
    type: RESET_CLOSEST_LVZ_PATHS,
})